// import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CardSkill from './CardSkill';
import { SkillsTest, SkillsFront, skillBack } from '../data/skills';

import '../styles/Skills.css';

export default class Skill extends Component {

  render() {
    const skills = [...SkillsFront, ...skillBack]
    return (
      <section className="container-skill animate__animated animate__slideInUp">
        <h3>Skills</h3>
        <div className="container-skills">
          <div className="skill">
            <h5>Front-end & Back-end</h5>
            <div className="container-cards">
              { 
              skills.map((skill, index) => (
                <CardSkill key={index} skills={skill} />
              ))}
            </div>
          </div>

          {/* <div className="skill">
            <h5>Back-end</h5>
            <div className="container-cards">
              { skillBack.map((skill, index) => (
                <CardSkill key={index} skills={skill} />
              ))}
            </div>
          </div> */}

          <div className="skill">
            <h5>Testes</h5>
            <div className="container-cards">
              { SkillsTest.map((skill, index) => (
                <CardSkill key={index} skills={skill} />
              ))}
            </div>
          </div>
          {/* <div className="skill">
            <h5>Ferramentas</h5>
            <div className="container-cards">
              { SkillsTolls.map((skill, index) => (
                <CardSkill key={index} skills={skill} />
              ))}
            </div>
          </div> */}
        </div>
      </section>
    )
  };
};
